module.exports = __webpack_public_path__ + "media/images/chat_close-08642cb4a603d6bb2d7b8f90730db09f.svg";